import { Button, FormLabel, FormRow, Input } from '@components/ui';
import { useApi } from '@data-access';
import { ErrorHelper } from '@helpers';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

import styles from './AddReportTypeForm.module.scss';

interface AddReportTypeFormProps {
  closeModal: () => void;
  onReportTypeCreated?: () => void;
}

export const AddReportTypeForm: React.FC<AddReportTypeFormProps> = ({ closeModal, onReportTypeCreated }) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();
  const { api } = useApi();

  const onFormSubmit = handleSubmit(async formData => {
    try {
      await api.apiReportTypesCreate({ reportType: { name: formData.name } });
      closeModal();
      onReportTypeCreated?.();
      toast.success('Successfully added report type', { autoClose: 6000 });
    } catch (error) {
      ErrorHelper.handleErrorNotification(error);
    }
  });

  return (
    <div className={styles.form}>
      <div className={styles.field}>
        <FormRow>
          <FormLabel
            id="name"
            className={styles.label}
          >
            <div>Report type name</div>
          </FormLabel>
          <Input
            props={{ ...register('name', { required: 'Please enter name' }) }}
            error={errors.name?.message as string}
            className={styles.select}
          />
        </FormRow>
      </div>

      <div className={styles.buttons}>
        <Button
          type="button"
          onClick={onFormSubmit}
        >
          Add
        </Button>
      </div>
    </div>
  );
};
